import React from "react";

const Error: React.FC = () => {
  return <div className="Error">Error</div>;
};

export default Error;
